import React, { FC } from "react";
import { EmbeddedAddress } from "services/graphql/generated";
import st from "./index.module.scss";

interface RenderedAddressProps {
  address: EmbeddedAddress | null;
}

export const RenderedAddress: FC<RenderedAddressProps> = ({ address }) => {
  if (!address) return <></>;
  const { firstName, lastName, company, line1, line2, city, state, zip } =
    address;

  const fullName = `${firstName} ${lastName}`.slice();
  const streetAddressInfo = `${line1}${line2?.length ? ", " + line2 : ""}`;
  const cityStateZipInfo = `${city}, ${state} ${zip}`.slice();
  return (
    <div className={st.address}>
      {(firstName || lastName) && <div>{fullName}</div>}
      {company && <div>{company}</div>}
      <div>{streetAddressInfo}</div>
      <div>{cityStateZipInfo}</div>
    </div>
  );
};
